/* eslint-disable no-unused-expressions */
import axios from "axios"
import headers from "../../util/headers"

export const getUserDetail = (baseUrl, unit_id) => {
  const path = `${baseUrl}/backend/users/details`
  return axios.get(path, { params: { id: unit_id }, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
}

export const getUsers = (baseUrl, params) => {
  const path = `${baseUrl}/backend/users`
  return axios.get(path, { params, ...headers() })
    .then(({ data, status, headers: resHeaders }) => ({ response: data, status, headers: resHeaders }))
}

export const getLearnWorldsEnrolments = (baseUrl, params) => {
  const path = `${baseUrl}/backend/users/learn_world_enrolments`
  return axios.get(path, { params, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
}

export const getUserReports = (baseUrl, params) => {
  const path = `${baseUrl}/backend/users/reports`
  return axios.get(path, { params, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
}

export const sendAdminResetPassword = (baseUrl, id) => {
  const path = `${baseUrl}/backend/users/send_reset_password_email`
  return axios.post(path, { id }, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const sendResendConfirmation = (baseUrl, id) => {
  const path = `${baseUrl}/backend/users/resend_confirmation_email`
  return axios.post(path, { id }, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const sendConfirmUserEmail = (baseUrl, id) => {
  const path = `${baseUrl}/backend/users/confirm_email`
  return axios.post(path, { id }, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const sendResetPassword = (baseUrl, email) => {
  const path = `${baseUrl}/users/send_reset_password_email`
  return axios.post(path, { email }, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const sendEnrolUserProgram = (baseUrl, params) => {
  const path = `${baseUrl}/backend/users/enrol_user_in_program`
  return axios.post(path, params, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const sendUnenrolUserProgram = (baseUrl, params) => {
  const path = `${baseUrl}/backend/users/unenrol_user_from_program`
  return axios.patch(path, params, headers())
    .then(({ data, status }) => ({ response: data, status }))
}